import axios from "axios";
import urlConfig from "../mixins/url";

class UserService {
  getUsersList() {
    var url = urlConfig.data().url.serverUrl + urlConfig.data().url.Auth.GetUsers;
    return axios.get(url);
  }

  changePassword(userId, password) {
    var url = urlConfig.data().url.serverUrl + urlConfig.data().url.Auth.ChangePassword;
    return axios.post(url, { userId: userId, password: password });
  }

  changeRoles(userId, roles) {
    var url = urlConfig.data().url.serverUrl + urlConfig.data().url.Auth.ChangeRoles;
    return axios.post(url, { userId, roles });
  }
}

export default new UserService();
